const initialState = { favorite: [] };

function favoriteReducer(state = initialState, action) {
  console.log(state, "ini state bos");
  switch (action.type) {
    case "ADD_TO_FAVORITE":
      return {
        ...state,
        favorite: state.favorite.concat(action.payload.favorite),
      };
    default:
      return state;
  }
}

export default favoriteReducer;
